import React from 'react';

import { Layout } from 'antd';

const Footer = () => {
  return (
    <Layout.Footer style={{ textAlign: 'center' }}>
      MinigamEZ @ le.minh.pham.hoang@gmail.com <br />
      Reviewed & approved by Facebook
    </Layout.Footer>
  );
};

export default Footer;
